import { useI18n } from '@/providers/i18n';
import { Share2 } from 'lucide-react';
import {
  getToolbarBtnCls,
  MoreToolPopover,
  ToolbarActionButton,
  TOOLBAR_SURFACE_CLS,
  TopToolbarShell,
  useTopToolbarState,
} from '@/components/nodes/shared/top-toolbar-kit';

type AudioTopToolbarProps = {
  nodeId: string;
  audioUrl?: string;
  isToolbarBlocked: boolean;
  onShare?: () => void;
};

/** 音频节点顶部工具栏：分享 / 更多（与图像、视频顶部工具栏同款交互）。 */
export function AudioTopToolbar({
  nodeId,
  audioUrl,
  isToolbarBlocked,
  onShare,
}: AudioTopToolbarProps) {
  const { t, i18n } = useI18n();
  const isZh = (i18n?.language || '').toLowerCase().startsWith('zh');
  const { isMultiSelect, shown, pointerEnabled } = useTopToolbarState(nodeId, Boolean(audioUrl));

  if (!audioUrl || isMultiSelect) return null;

  const btnCls = getToolbarBtnCls(isZh);
  return (
    <TopToolbarShell shown={shown} pointerEnabled={pointerEnabled}>
      {/* 隐藏时不构建按钮 JSX 树，避免画布上每个节点的无谓渲染开销（与图像/视频一致） */}
      {shown ? (
        <div className={TOOLBAR_SURFACE_CLS}>
          <div className="flex items-center gap-1">
            {onShare && (
              <ToolbarActionButton
                icon={Share2}
                label={t('Share')}
                className={btnCls}
                disabled={isToolbarBlocked}
                onClick={onShare}
              />
            )}
            <MoreToolPopover nodeId={nodeId} url={audioUrl} disabled={isToolbarBlocked} triggerCls={btnCls} />
          </div>
        </div>
      ) : null}
    </TopToolbarShell>
  );
}
